<template>
  <div class="w-[100vw] h-[100vh] fixed top-0 left-0 flex justify-center items-center bg-[#0000005a]">
    <div class="w-[40vw] text-white gap-4 p-4 bg-[#5D5D98] rounded-[10px] flex flex-col">
      <div class="w-full flex gap-2 justify-between items-center">
        <h3 class="text-[#ff9b05]">Filtro</h3>
        <AppButton class="text-white" v-bind:visibility="true" left_icon="fa-regular fa-circle-xmark fa-xl"
          emitType="close" @close="close" :width="23" :height="23" />
      </div>

      <!-- TPA -->
<div class="flex gap-2 items-center">
  <label class="min-w-[6.5rem]">TPA:</label>
  <input :disabled="true" type="text" v-model="tpa_concat" class="text-black text-[16px] border border-[#ccc] p-1 rounded-[5px] w-full">
  <button class="fa-solid fa-pen-to-square text-2xl" :style="{ color: '#ff9b05' }" @click="open_dialog_alert('tpa')"></button>
  <button :style="{ color: 'red' }" @click="remove('tpa')">
    <i class="fa-regular fa-circle-xmark text-2xl"></i>
  </button>
</div>

<div class="flex gap-2 items-center">
  <label class="min-w-[6.5rem]">Chefe:</label>
  <input :disabled="true" type="text" v-model="chefe_concat" class="text-black text-[16px] border border-[#ccc] p-1 rounded-[5px] w-full">
  <button class="fa-solid fa-pen-to-square text-2xl" :style="{ color: '#ff9b05' }" @click="open_dialog_alert('chefe')"></button>
  <button :style="{ color: 'red' }" @click="remove('chefe')">
    <i class="fa-regular fa-circle-xmark text-2xl"></i>
  </button>
</div>

<div class="flex gap-2 items-center">
  <label class="min-w-[6.5rem]">Responsável:</label>
  <input :disabled="true" type="text" v-model="responsavel_concat" class="text-black text-[16px] border border-[#ccc] p-1 rounded-[5px] w-full">
  <button class="fa-solid fa-pen-to-square text-2xl" :style="{ color: '#ff9b05' }" @click="open_dialog_alert('responsavel')"></button>
  <button :style="{ color: 'red' }" @click="remove('responsavel')">
    <i class="fa-regular fa-circle-xmark text-2xl"></i>
  </button>
</div>


<!-- Cert. RAE -->
<div class="flex gap-2 items-center">
  <label class="min-w-[6.5rem]">Cert. RAE:</label>
  <input :disabled="true" type="text" v-model="cert_rae_concat" class="text-black text-[16px] border border-[#ccc] p-1 rounded-[5px] w-full">
  <button class="fa-solid fa-pen-to-square text-2xl" :style="{ color: '#ff9b05' }" @click="open_dialog_alert('cert_rae')"></button>
  <button :style="{ color: 'red' }" @click="remove('cert_rae')">
    <i class="fa-regular fa-circle-xmark text-2xl"></i>
  </button>
</div>


      <div class="flex gap-2 items-center">
        <label class="min-w-[6.5rem]">Viatura:</label>
        <input :disabled="true" type="text" v-model="viatura_concat" class="text-black text-[16px] border border-[#ccc] p-1 rounded-[5px] w-full">
        <button class="fa-solid fa-pen-to-square text-2xl" :style="{ color: '#ff9b05' }" @click="open_dialog_alert('viatura')"></button>
        <button :style="{ color: 'red' }" @click="remove('viatura')">
          <i class="fa-regular fa-circle-xmark text-2xl"></i>
        </button>
      </div>

      <div class="flex gap-2 items-center">
        <label class="min-w-[6.5rem]">Computador:</label>
        <input :disabled="true" type="text" v-model="computador_concat" class="text-black text-[16px] border border-[#ccc] p-1 rounded-[5px] w-full">
        <button class="fa-solid fa-pen-to-square text-2xl" :style="{ color: '#ff9b05' }" @click="open_dialog_alert('computador')"></button>
        <button :style="{ color: 'red' }" @click="remove('computador')">
          <i class="fa-regular fa-circle-xmark text-2xl"></i>
        </button>
      </div>

      

      <!-- Tipo Utilizador -->
      <div class="flex gap-2 items-center">
        <label class="min-w-[6.5rem]">Tipo Utilizador:</label>
        <input :disabled="true" type="text" v-model="tp_utilizador_concat" class="text-black text-[16px] border border-[#ccc] p-1 rounded-[5px] w-full">
        <button class="fa-solid fa-pen-to-square text-2xl" :style="{ color: '#ff9b05' }" @click="open_dialog_alert('tp_utilizador')"></button>
        <button :style="{ color: 'red' }" @click="remove('tp_utilizador')">
          <i class="fa-regular fa-circle-xmark text-2xl"></i>
        </button>
      </div>

      
      <div class="flex gap-2 items-center">
        <label class="min-w-[6.5rem]">Valência:</label>
        <input :disabled="true" type="text" v-model="valencias_concat" class="text-black text-[16px] border border-[#ccc] p-1 rounded-[5px] w-full">
        <button class="fa-solid fa-pen-to-square text-2xl" :style="{ color: '#ff9b05' }" @click="open_dialog_alert('valencias')"></button>
        <button :style="{ color: 'red' }" @click="remove('valencias')">
          <i class="fa-regular fa-circle-xmark text-2xl"></i>
        </button>
      </div>

      <!-- Tipo Documento -->
      <div class="flex gap-2 items-center">
        <label class="min-w-[6.5rem]">Tipo Documento:</label>
        <input :disabled="true" type="text" v-model="tipo_documento_concat" class="text-black text-[16px] border border-[#ccc] p-1 rounded-[5px] w-full">
        <button class="fa-solid fa-pen-to-square text-2xl" :style="{ color: '#ff9b05' }" @click="open_dialog_alert('tpdocumento')"></button>
        <button :style="{ color: 'red' }" @click="remove('tipo_documento')">
          <i class="fa-regular fa-circle-xmark text-2xl"></i>
        </button>
      </div>

      <!-- Status -->
      <div class="flex gap-2 items-center">
        <label class="min-w-[6.5rem]">Status:</label>
        <input :disabled="true" type="text" v-model="status_concat" class="text-black text-[16px] border border-[#ccc] p-1 rounded-[5px] w-full">
        <button class="fa-solid fa-pen-to-square text-2xl" :style="{ color: '#ff9b05' }" @click="open_dialog_alert('status')"></button>
        <button :style="{ color: 'red' }" @click="remove('status')">
          <i class="fa-regular fa-circle-xmark text-2xl"></i>
        </button>
      </div>

      <div class="flex gap-4 mt-4">
        <AppButton :padding="'var(--padding_btn)'" class="capitalize mb-auto" v-bind:visibility="true"
          :font_size="12" color="#ff9b05" left_icon="fa-solid fa-pen-to-square" text="Confirmar"
          emitType="select" @select="salvar_filtro" />
        <AppButton :padding="'var(--padding_btn)'" class="capitalize mb-auto" v-bind:visibility="true"
          :font_size="12" color="red" left_icon="fa-regular fa-rectangle-xmark" text="Cancelar"
          emitType="select" @select="close" />
      </div>

      
    </div>
  </div>

  <Dialog v-if="showDialog" :propsData="dialogProps" @close="closeDialog" @returnData="handleReturnData" :pagination="true" :multiSelectOptions="{ enabled: true, show_btn: false }" />
  <StaticMultiTable v-if="showStaticTable" :title="staticTable_title" :data="StaticTableData" @returnData="handleReturnData" @close="showStaticTable = false" />
</template>

<script>
import AppButton from '@/components/updated/button.vue'
import Dialog from '@/components/dialog/dinamicDialog.vue'
import StaticMultiTable from '@/components/tables/multiSelectTable.vue'

export default {
  components: { AppButton, Dialog, StaticMultiTable },
  props: {
        data: {
            type: Object,
            default: () => { }
        }

    },
  data() {
    return {
      status: [],
      status_concat: '',

      viatura: [],
      viatura_concat: '',

      computador: [],
      computador_concat: '',

      tpa: [],
      tpa_concat: '',

      chefe: [],
      chefe_concat: '',

      cert_rae: [],
      cert_rae_concat: '',

      responsavel: [],
      responsavel_concat: '',


      tp_utilizador: [],
      tp_utilizador_concat: '',

      valencias: [],
      valencias_concat: '',

      tipo_documento: [],
      tipo_documento_concat: '',

      dialogProps: { entity: [''], title: '', sideBar: true },
      currentType: '',
      showDialog: false,
      showStaticTable: false,
      staticTable_title: '',
      StaticTableData: []
    }
  },
  
  methods: {
    close() { this.$emit('close') },
    salvar_filtro() {
      this.$emit('save', {
        viatura: this.viatura,
        computador: this.computador,
        tpa: this.tpa,
        chefe: this.chefe,
        cert_rae: this.cert_rae,
        responsavel: this.responsavel,

        status: this.status,
        tp_utilizador: this.tp_utilizador,
        valencias: this.valencias,
        tipo_documento: this.tipo_documento,
      })
    },
    open_dialog_alert(key) {
      if (key === 'tp_utilizador') {
        this.dialogProps.entity[0] = 'tputilizador'
        this.currentType = 'tp_utilizador'
        this.showDialog = true
      } else if (key === 'tpdocumento') {
        this.dialogProps.entity[0] = 'tpdocumento'
        this.currentType = 'tipo_documento'
        this.showDialog = true
      } else if (key === 'valencias') {
        this.dialogProps.entity[0] = 'tpvalencia'
        this.currentType = 'valencias'
        this.showDialog = true
      } else if (key === 'responsavel') {
        this.dialogProps.entity[0] = 'responsavel'
        this.currentType = 'responsavel'
        this.showDialog = true
      } else if (key === 'chefe') {
        this.dialogProps.entity[0] = 'chefe'
        this.currentType = 'chefe'
        this.showDialog = true
      } else if (key === 'status') {
        this.StaticTableData = [
          { id: 1, nome: 'ativo' },
          { id: 2, nome: 'desativado' }
        ]
        this.staticTable_title = 'Status'
        this.showStaticTable = true
      } else if (key === 'viatura') {
        this.StaticTableData = [
          { id: 1, nome: 'sim' },
          { id: 2, nome: 'nao' }
        ]
        this.staticTable_title = 'Viatura'
        this.showStaticTable = true
      } else if (key === 'computador') {
        this.StaticTableData = [
          { id: 1, nome: 'sim' },
          { id: 2, nome: 'nao' }
        ]
        this.staticTable_title = 'Computador'
        this.showStaticTable = true
      } else if (key === 'tpa') {
        this.StaticTableData = [
          { id: 1, nome: 'sim' },
          { id: 2, nome: 'nao' }
        ]
        this.staticTable_title = 'TPA'
        this.showStaticTable = true
      } else if (key === 'cert_rae') {
        this.StaticTableData = [
          { id: 1, nome: 'sim' },
          { id: 2, nome: 'nao' }
        ]
        this.staticTable_title = 'CertRAE'
        this.showStaticTable = true
      } 


    },
    handleReturnData(data) {
      console.log("Returned datadatadata:", data);
  if (data.tputilizador) {
    this.tp_utilizador = Array.isArray(data.tputilizador) ? data.tputilizador : [data.tputilizador];
    this.tp_utilizador_concat = this.tp_utilizador.map(d => d.nome).join(', ');
  } else if (data.tpdocumento) {
    this.tipo_documento = Array.isArray(data.tpdocumento) ? data.tpdocumento : [data.tpdocumento];
    this.tipo_documento_concat = this.tipo_documento.map(d => d.nome).join(', ');
  } else if (data.tpvalencia) {
    this.valencias = Array.isArray(data.tpvalencia) ? data.tpvalencia : [data.tpvalencia];
    this.valencias_concat = this.valencias.map(d => d.nome).join(', ');
  } else if (data.Status) {
    this.status = Array.isArray(data.Status) ? data.Status.map(d => d.nome) : [data.Status.nome];
    this.status_concat = this.status.join(', ');
  } else if (data.Viatura) {
    this.viatura = Array.isArray(data.Viatura) ? data.Viatura.map(d => d.nome) : [data.Viatura.nome];
    this.viatura_concat = this.viatura.join(', ');
  } else if (data.Computador) {
    this.computador = Array.isArray(data.Computador) ? data.Computador.map(d => d.nome) : [data.Computador.nome];
    this.computador_concat = this.computador.join(', ');
  } else if (data.TPA) {
    this.tpa = Array.isArray(data.TPA) ? data.TPA.map(d => d.nome) : [data.TPA.nome]
    this.tpa_concat = this.tpa.join(', ')
  } else if (data.CertRAE) {
    this.cert_rae = Array.isArray(data.CertRAE) ? data.CertRAE.map(d => d.nome) : [data.CertRAE.nome]
    this.cert_rae_concat = this.cert_rae.join(', ')
  } else if (data.chefe) {
    this.chefe = Array.isArray(data.chefe) ? data.chefe : [data.chefe]
    this.chefe_concat = this.chefe.map(d => d.user).join(', ')
  } else if (data.responsavel) {
    this.responsavel = Array.isArray(data.responsavel) ? data.responsavel : [data.responsavel]
    this.responsavel_concat = this.responsavel.map(d => d.user).join(', ')
  }


}
,
    closeDialog() {
      this.showDialog = false
    },
    remove(key) { if (key === 'tp_utilizador') {
  this.tp_utilizador = []
  this.tp_utilizador_concat = ''
}
      else if (key === 'tipo_documento') this.tipo_documento = this.tipo_documento_concat = ''
      else if (key === 'valencias') this.valencias = this.valencias_concat = ''
      else if (key === 'status') this.status = this.status_concat = ''
      else if (key === 'viatura') this.viatura = this.viatura_concat = ''
      else if (key === 'computador') this.computador = this.computador_concat = ''
      else if (key === 'tpa') this.tpa = this.tpa_concat = ''
      else if (key === 'cert_rae') this.cert_rae = this.cert_rae_concat = ''
      else if (key === 'chefe') this.chefe = this.chefe_concat = ''
      else if (key === 'responsavel') this.responsavel = this.responsavel_concat = ''

    },
    

    
  },
  created() {
  if (this.data) {
    this.viatura = this.data.viatura || [];
    this.viatura_concat = this.viatura.map(d => d.nome || d).join(', ');

    this.tpa = this.data.tpa || []
    this.tpa_concat = this.tpa.map(d => d.nome || d).join(', ')

    this.cert_rae = this.data.cert_rae || []
    this.cert_rae_concat = this.cert_rae.map(d => d.nome || d).join(', ')

    this.chefe = this.data.chefe || []
    this.chefe_concat = this.chefe.map(d => d.user || d).join(', ')


    this.computador = this.data.computador || [];
    this.computador_concat = this.computador.map(d => d.nome || d).join(', ');

    this.responsavel = this.data.responsavel || []
    this.responsavel_concat = this.responsavel.map(d => d.user).join(', ')

    this.status = this.data.status || [];
    this.status_concat = this.status.map(d => d.nome || d).join(', ');

    this.tp_utilizador = this.data.tp_utilizador || [];
    this.tp_utilizador_concat = this.tp_utilizador.map(d => d.nome).join(', ');

    this.valencias = this.data.valencias || [];
    this.valencias_concat = this.valencias.map(d => d.nome).join(', ');

    this.tipo_documento = this.data.tipo_documento || [];
    this.tipo_documento_concat = this.tipo_documento.map(d => d.nome).join(', ');
  }
}
,
watch: {
  data: {
    handler(val) {
      if (val) {
        this.computador = val.computador || [];
        this.computador_concat = this.computador.map(d => d.nome || d).join(', ');

        this.viatura = val.viatura || [];
        this.viatura_concat = this.viatura.map(d => d.nome || d).join(', ');

        this.tpa = val.tpa || []
        this.tpa_concat = this.tpa.map(d => d.nome || d).join(', ')

        this.cert_rae = val.cert_rae || []
        this.cert_rae_concat = this.cert_rae.map(d => d.nome || d).join(', ')

        this.chefe = val.chefe || []
        this.chefe_concat = this.chefe.map(d => d.nome || d).join(', ')

        this.responsavel = val.responsavel || []
        this.responsavel_concat = this.responsavel.map(d => d.nome).join(', ')

        this.status = val.status || [];
        this.status_concat = this.status.map(d => d.nome || d).join(', ');

        this.tp_utilizador = val.tp_utilizador || [];
        this.tp_utilizador_concat = this.tp_utilizador.map(d => d.nome).join(', ');

        this.valencias = val.valencias || [];
        this.valencias_concat = this.valencias.map(d => d.nome).join(', ');

        this.tipo_documento = val.tipo_documento || [];
        this.tipo_documento_concat = this.tipo_documento.map(d => d.nome).join(', ');
      }
    },
    immediate: true,
    deep: true
  }
}
}
</script>
